import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=25d71ba6"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=25d71ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports